import { Grid, CircularProgress } from '@mui/material';

import GoBack from 'js/containers/GoBack.jsx';
import { trackEventMatomoVisit } from 'js/library/utils/helpers';
import { useCurrentUserInfo } from 'js/library/services/currentUserInfo';
import { recommendOrgs } from 'js/library/utils/API/recommendOrgs.js';
import OrganizationItem from 'js/containers/Organizations/OrganizationItem';
import { useState, useEffect } from 'react';

export default function AddOrganizations() {
  const [orgs, setOrgs] = useState(null);
  const { userInfo } = useCurrentUserInfo();

  useEffect(() => {
    document.title = 'Adicionar organizacao';
    trackEventMatomoVisit('Adicionar organizacao');
  });

  useEffect(() => {
    (async function fetchRecommendedOrgs() {
      try {
        if (orgs === null) {
          const result = await recommendOrgs(userInfo.uId);
          setOrgs(result);
        }
      } catch (error) {
        setOrgs(false);
        console.error('Error fetching recommended organizations:', error);
      }
    })();
  }, [orgs, userInfo?.uId]);

  return (
    <div>
      {orgs === null ? (
        <div style={{ textAlign: 'center' }} className="loading-content">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <GoBack />

          <Grid container spacing={0}>
            {orgs.map((row, i) => {
              return <OrganizationItem key={i} data={row} />;
            })}
          </Grid>
        </div>
      )}
    </div>
  );
}
